const formatLorryNum = (lorryNumber) => {
    if (!lorryNumber) {
        return "";
    }
    const lorryNum = lorryNumber.replaceAll(" ", "").toUpperCase();
    let formattedLorryNumArray = [];
    let currentSegment = lorryNum[0];
    let isPrevCharNumber = false;
    let isCurrentCharNumber = !isNaN(parseInt(lorryNum[0]));
    for (let i = 1; i < lorryNum.length; i++) {
        isCurrentCharNumber = !isNaN(parseInt(lorryNum[i]));
        if (isCurrentCharNumber === isPrevCharNumber) {
            currentSegment += lorryNum[i];
        }
        else {
            formattedLorryNumArray.push(currentSegment);
            currentSegment = "" + lorryNum[i];
        }
        isPrevCharNumber = isCurrentCharNumber;
    }
    formattedLorryNumArray.push(currentSegment);
    const formattedLorryNumber = formattedLorryNumArray.join(" ");
    return formattedLorryNumber;
};

export { formatLorryNum };
//# sourceMappingURL=formatLorryNum.js.map
